export default {
  sections: [
  {
    "id": "inspector",
    "title": "Registered Inspector's Details",
    "repeatable": false,
    "fields": [
      {
        "id": "name",
        "type": "text",
        "label": "Name",
        "required": true
      },
      {
        "id": "address",
        "type": "textarea",
        "label": "Address",
        "required": true
      },
      {
        "id": "postCode",
        "type": "text",
        "label": "Post Code",
        "required": true
      },
      {
        "id": "tel",
        "type": "tel",
        "label": "Telephone",
        "required": true
      },
      {
        "id": "gasRegNumber",
        "type": "text",
        "label": "Gas Safe Reg No.",
        "required": true,
        "placeholder": "e.g. 183033"
      }
    ]
  },
  {
    "id": "property",
    "title": "Property Details",
    "repeatable": false,
    "fields": [
      {
        "id": "address",
        "type": "textarea",
        "label": "Property Address",
        "required": true
      },
      {
        "id": "postCode",
        "type": "text",
        "label": "Post Code",
        "required": true
      },
      {
        "id": "landlord",
        "type": "text",
        "label": "Landlord Name",
        "required": true
      },
      {
        "id": "tenant",
        "type": "text",
        "label": "Tenant Name"
      }
    ]
  },
  {
    "id": "appliances",
    "title": "Appliances Tested",
    "repeatable": true,
    "fields": [
      {
        "id": "location",
        "type": "text",
        "label": "Location",
        "required": true
      },
      {
        "id": "type",
        "type": "select",
        "label": "Type",
        "required": true,
        "options": [
          "Boiler",
          "Fire",
          "Cooker",
          "Water Heater",
          "Other"
        ]
      },
      {
        "id": "make",
        "type": "text",
        "label": "Make/Model"
      },
      {
        "id": "safetyCheck",
        "type": "select",
        "label": "Safety Check",
        "required": true,
        "options": [
          "Pass",
          "Fail",
          "N/A"
        ]
      }
    ]
  },
  {
    "id": "certification",
    "title": "Certification",
    "repeatable": false,
    "fields": [
      {
        "id": "inspectionDate",
        "type": "date",
        "label": "Inspection Date",
        "required": true
      },
      {
        "id": "nextInspectionDate",
        "type": "date",
        "label": "Next Inspection Due",
        "required": true
      },
      {
        "id": "certificateNumber",
        "type": "text",
        "label": "Certificate Number",
        "required": true
      },
      {
        "id": "engineerSignature",
        "type": "signature",
        "label": "Engineer Signature",
        "required": true
      },
      {
        "id": "engineerName",
        "type": "text",
        "label": "Engineer Name (Print)",
        "required": true
      }
    ]
  }
]
};
